export function getByteSize(str){
  return encodeURI(str).split(/%..|./).length - 1;
}